import { AfterViewInit, Component, OnInit } from '@angular/core';
import { categoryDB } from '../../../../shared/tables/category';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LocalDataSource } from 'ng2-smart-table';
import { CollectionDTO } from 'src/app/shared/models/model';
import { collectionService } from 'src/app/shared/service/collection.service';


@Component({
    selector: 'app-collection',
    templateUrl: './collection.component.html',
    styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {
    public closeResult: string;
    public Source: LocalDataSource;
    public Collection: CollectionDTO = new CollectionDTO();
    public collectionList: CollectionDTO[] = [];

    constructor(private modalService: NgbModal,private collectionService:collectionService) {
        this.Source = new LocalDataSource();
        this.Collection = new CollectionDTO();
 
        this.collectionService.getCollections().subscribe(data => {
            this.collectionList = data;
            this.Source = new LocalDataSource(this.collectionList);
        });
      
        console.log(this.Source);
    }


    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    updateRecord(event) {
        this.Collection.description = event.newData.description;
        this.Collection.idcollection = event.newData.idcollection;
        this.collectionService.updateCollection(this.Collection);
        
        event.confirm.resolve(event.newData);

    }

    deleteRecord(event) {
        this.Collection = new CollectionDTO();
        console.log(event.data.idcollection);
        this.collectionService.deleteCollection(event.data.idcollection);
        event.confirm.resolve(event.newData);
    }


    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    public settings = {
        "mode": "inline",
        delete: {
            "confirmDelete": "true"
        },
        edit: { "confirmSave": "true" },
        actions: {
            position: 'right',
            update: true
        },
        columns: {
            idcollection: {
                title: 'IdCollection'
            },
            description: {
                title: 'Collection Description'
            }
        },
    };
    ngOnInit(): void {
        // this.Source = this.branService.getCollections();
        // console.log(this.Source);
    }

    onSubmit(collectionForm) {
        debugger
        this.Collection = new CollectionDTO();
        this.Collection.description = collectionForm.value["Collection"];
        console.log(this.Collection);
        this.collectionService.addCollection(this.Collection);
        // window.location.reload();
      }

}
function collapseAnimation() {
    throw new Error('Function not implemented.');
}
